/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { MktuClassShort } from './MktuClassShort'
import {
  MktuClassShortFromJSON,
  MktuClassShortFromJSONTyped,
  MktuClassShortToJSON,
} from './MktuClassShort'
import type { ApplicationFirstStageDataCustomerOrganizationData } from './ApplicationFirstStageDataCustomerOrganizationData'
import {
  ApplicationFirstStageDataCustomerOrganizationDataFromJSON,
  ApplicationFirstStageDataCustomerOrganizationDataFromJSONTyped,
  ApplicationFirstStageDataCustomerOrganizationDataToJSON,
} from './ApplicationFirstStageDataCustomerOrganizationData'
import type { OrganizationType } from './OrganizationType'
import {
  OrganizationTypeFromJSON,
  OrganizationTypeFromJSONTyped,
  OrganizationTypeToJSON,
} from './OrganizationType'
import type { ImageSignType } from './ImageSignType'
import {
  ImageSignTypeFromJSON,
  ImageSignTypeFromJSONTyped,
  ImageSignTypeToJSON,
} from './ImageSignType'

/**
 *
 * @export
 * @interface ApplicationThirdStageData
 */
export interface ApplicationThirdStageData {
  /**
   * Если указывается наименование, поля file, imageSighType не должны передаваться
   * @type {string}
   * @memberof ApplicationThirdStageData
   */
  brand?: string
  /**
   *
   * @type {string}
   * @memberof ApplicationThirdStageData
   */
  image?: string
  /**
   *
   * @type {ImageSignType}
   * @memberof ApplicationThirdStageData
   */
  imageType?: ImageSignType
  /**
   * Признак совпадения данных заказчик (кто подает) и правообладателя (на кого подают)
   * @type {boolean}
   * @memberof ApplicationThirdStageData
   */
  isEqual?: boolean
  /**
   *
   * @type {OrganizationType}
   * @memberof ApplicationThirdStageData
   */
  customerOrganizationType?: OrganizationType
  /**
   *
   * @type {OrganizationType}
   * @memberof ApplicationThirdStageData
   */
  ownerOrganizationType?: OrganizationType
  /**
   *
   * @type {ApplicationFirstStageDataCustomerOrganizationData}
   * @memberof ApplicationThirdStageData
   */
  customerOrganizationData?: ApplicationFirstStageDataCustomerOrganizationData
  /**
   *
   * @type {ApplicationFirstStageDataCustomerOrganizationData}
   * @memberof ApplicationThirdStageData
   */
  ownerOrganizationData?: ApplicationFirstStageDataCustomerOrganizationData
  /**
   * Список выбранных слов по классам МКТУ
   * @type {Array<MktuClassShort>}
   * @memberof ApplicationThirdStageData
   */
  mktuList: Array<MktuClassShort>
}

/**
 * Check if a given object implements the ApplicationThirdStageData interface.
 */
export function instanceOfApplicationThirdStageData(
  value: object
): value is ApplicationThirdStageData {
  if (!('mktuList' in value) || value['mktuList'] === undefined) return false
  return true
}

export function ApplicationThirdStageDataFromJSON(
  json: any
): ApplicationThirdStageData {
  return ApplicationThirdStageDataFromJSONTyped(json, false)
}

export function ApplicationThirdStageDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationThirdStageData {
  if (json == null) {
    return json
  }
  return {
    brand: json['brand'] == null ? undefined : json['brand'],
    image: json['image'] == null ? undefined : json['image'],
    imageType:
      json['imageType'] == null
        ? undefined
        : ImageSignTypeFromJSON(json['imageType']),
    isEqual: json['isEqual'] == null ? undefined : json['isEqual'],
    customerOrganizationType:
      json['customerOrganizationType'] == null
        ? undefined
        : OrganizationTypeFromJSON(json['customerOrganizationType']),
    ownerOrganizationType:
      json['ownerOrganizationType'] == null
        ? undefined
        : OrganizationTypeFromJSON(json['ownerOrganizationType']),
    customerOrganizationData:
      json['customerOrganizationData'] == null
        ? undefined
        : ApplicationFirstStageDataCustomerOrganizationDataFromJSON(
            json['customerOrganizationData']
          ),
    ownerOrganizationData:
      json['ownerOrganizationData'] == null
        ? undefined
        : ApplicationFirstStageDataCustomerOrganizationDataFromJSON(
            json['ownerOrganizationData']
          ),
    mktuList: (json['mktuList'] as Array<any>).map(MktuClassShortFromJSON),
  }
}

export function ApplicationThirdStageDataToJSON(
  value?: ApplicationThirdStageData | null
): any {
  if (value == null) {
    return value
  }
  return {
    brand: value['brand'],
    image: value['image'],
    imageType: ImageSignTypeToJSON(value['imageType']),
    isEqual: value['isEqual'],
    customerOrganizationType: OrganizationTypeToJSON(
      value['customerOrganizationType']
    ),
    ownerOrganizationType: OrganizationTypeToJSON(
      value['ownerOrganizationType']
    ),
    customerOrganizationData:
      ApplicationFirstStageDataCustomerOrganizationDataToJSON(
        value['customerOrganizationData']
      ),
    ownerOrganizationData:
      ApplicationFirstStageDataCustomerOrganizationDataToJSON(
        value['ownerOrganizationData']
      ),
    mktuList: (value['mktuList'] as Array<any>).map(MktuClassShortToJSON),
  }
}
